import { DecodeHtml } from "../../utils/decodeHtml"
import { PropTypes } from 'prop-types';
import { retrunAssets } from "../../utils/getAssets";

const Info = ({ research }) => {




    const description1 = DecodeHtml({ html: research?.description1?.markup })
    const description2 = DecodeHtml({ html: research?.description11?.markup })
    const description3 = research?.description12?.split("\n\n")[0]
    const email = research?.description12?.split(":")[1]



    const img = research?.image1 != null ? retrunAssets(research?.image1[0]?.url) : ""
    return (
        <div className="grid gap-10 pt-8 border-t border-dashed border-t-[#07194633] text-[#081330]">
            {description1}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">

                <div className="w-full max-w-5xl h-[20rem]  2xl:max-w-7xl 2xl:h-[25rem] rounded-xl overflow-hidden  bg-gray-200">
                    <img src={img} alt="Professional Services" className="max-w-full w-full h-full object-cover" />
                </div>
                {
                    description2
                }
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-[70%_30%] gap-10 p-8 border rounded-xl">

                <p className="w-auto  text-justify text-sky-900  text-base font-normal leading-normal">{description3}</p>
                <p className="w-auto  text-justify text-sky-900  text-base font-normal leading-normal">Email : <a href={`mailto:${email}}`}>{email}</a> </p>

            </div>
        </div>
    )
}
Info.propTypes = {
    research: PropTypes.any
}
export default Info